import React, { useState, useEffect } from 'react';

import { format } from 'date-fns';
import { NotificationContainer } from 'react-notifications';
import api from '../../services/api';
import MediaManagerContext from './MediaManagerContext';

import NavBar from '../../components/NavBar';
import Loader from '../../components/Loader';
import Error from '../../components/Error';
import Line from '../../components/Line';
import NavTabsGeneral from '../../components/NavTabsGeneral';

import TabInfo from './Tabs/Info';
import TabImage from './Tabs/Image';
import TabLink from './Tabs/Link';

import * as S from './styles';

const MediaManager = props => {
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [isContent, setContent] = useState(false);
  const [isNewData, setNewData] = useState(false);
  const [objData, setData] = useState({});

  const auxFormatData = data => {
    data.id = data.medId;
    switch (data.medStatus) {
      case 0:
        data._medStatus = 'Active';
        break;
      case 1:
        data._medStatus = 'Processing';
        break;
      case 2:
        data._medStatus = 'Disabled';
        break;
      case 3:
        data._medStatus = 'Blocked';
        break;
      default:
        data._medStatus = 'Disabled';
        break;
    }
    switch (data.medFeaturedMain) {
      case 0:
        data._medFeaturedMain = 'Active';
        break;
      case 1:
        data._medFeaturedMain = 'Disabled';
        break;
      default:
        data._medFeaturedMain = 'Disabled';
        break;
    }
    switch (data.medFeatured) {
      case 0:
        data._medFeatured = 'Active';
        break;
      case 1:
        data._medFeatured = 'Disabled';
        break;
      default:
        data._medFeatured = 'Disabled';
        break;
    }
    for (let c = 0; c < data.CATEGORY.length; c++) {
      data[`medCategory${c + 1}`] = data.CATEGORY[c].catId;
    }
    data._medDateCreated = format(new Date(data.medDateCreated), 'MM/dd/yyyy');
    data._medDateUpdated = format(new Date(data.medDateUpdated), 'MM/dd/yyyy');
    return data;
  };

  useEffect(() => {
    async function loadData() {
      const {
        match: {
          params: { id },
        },
      } = props;

      if (id === 'new') {
        // New Data
        setNewData(true);
        viewContent();
      } else {
        const apiGetData = api('GET', `/media/${id}`, null);

        const resGetData = await apiGetData;
        const {
          data: { resData },
        } = resGetData;
        console.log(resData);
        // console.log(auxFormatData(resData));
        setData(auxFormatData(resData));
        viewContent();
      }
    }
    try {
      loadData();
    } catch (error) {
      viewError();
    }
  }, []);

  const viewData = () => {
    return (
      <S.DivData>
        <NavTabsGeneral
          propContext={objData}
          propTabs={[
            {
              title: 'Info',
              component: <TabInfo propData={objData} propNewData={isNewData} />,
            },
            !isNewData && {
              title: 'Images',
              component: <TabImage propData={objData} />,
            },
            !isNewData && {
              title: 'Links',
              component: <TabLink propData={objData} />,
            },
          ]}
        />
      </S.DivData>
    );
  };

  const viewLoading = status => {
    if (status === undefined) {
      console.log('type A');
      setContent(false);
      setError(false);
      setLoading(true);
    } else {
      console.log('type B');
      setLoading(status);
    }
  };

  const viewError = () => {
    setContent(false);
    setLoading(false);
    setError(true);
  };

  const viewContent = () => {
    setLoading(false);
    setError(false);
    setContent(true);
  };

  return (
    <>
      <NavBar />
      <S.Container>
        <S.ContainerHeader>
          <S.Title>Media</S.Title>
          <Line />
        </S.ContainerHeader>
        <S.ContainerContent>
          <MediaManagerContext.Provider
            value={{ viewLoading, viewError, viewContent }}
          >
            {isLoading && <Loader />}
            {isError && <Error />}
            {isContent && viewData()}
            {/* {isLoading ? <Loader /> : viewData()} */}
          </MediaManagerContext.Provider>
        </S.ContainerContent>
      </S.Container>
      <NotificationContainer />
    </>
  );
};

export default MediaManager;
